import { Directive } from '@angular/core';

@Directive({
  selector: '[appGuideCardDescription]',
})
export class GuideCardDescriptionDirective {}
